<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0_262_11027"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
        >
            <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_262_11027)">
            <path
                d="M11.5 9.5C12.1944 9.5 12.7847 9.25694 13.2708 8.77083C13.7569 8.28472 14 7.69444 14 7C14 6.30556 13.7569 5.71528 13.2708 5.22917C12.7847 4.74306 12.1944 4.5 11.5 4.5C10.8056 4.5 10.2153 4.74306 9.72917 5.22917C9.24306 5.71528 9 6.30556 9 7C9 7.69444 9.24306 8.28472 9.72917 8.77083C10.2153 9.25694 10.8056 9.5 11.5 9.5ZM6.5 15C6.0875 15 5.73438 14.8531 5.44062 14.5594C5.14687 14.2656 5 13.9125 5 13.5V3.5C5 3.0875 5.14687 2.73438 5.44062 2.44063C5.73438 2.14688 6.0875 2 6.5 2H16.5C16.9125 2 17.2656 2.14688 17.5594 2.44063C17.8531 2.73438 18 3.0875 18 3.5V13.5C18 13.9125 17.8531 14.2656 17.5594 14.5594C17.2656 14.8531 16.9125 15 16.5 15H6.5ZM3.5 18C3.0875 18 2.73438 17.8531 2.44063 17.5594C2.14688 17.2656 2 16.9125 2 16.5V5.75C2 5.5375 2.07146 5.35937 2.21438 5.21562C2.35729 5.07187 2.53437 5 2.74562 5C2.95687 5 3.13542 5.07187 3.28125 5.21562C3.42708 5.35937 3.5 5.5375 3.5 5.75V16.5H14.25C14.4625 16.5 14.6406 16.5715 14.7844 16.7144C14.9281 16.8573 15 17.0344 15 17.2456C15 17.4569 14.9281 17.6354 14.7844 17.7812C14.6406 17.9271 14.4625 18 14.25 18H3.5ZM6.5 13.5H16.5V12.8542C15.875 12.1042 15.1281 11.5243 14.2592 11.1146C13.3904 10.7049 12.4703 10.5 11.4988 10.5C10.5274 10.5 9.60764 10.7049 8.73958 11.1146C7.87153 11.5243 7.125 12.1042 6.5 12.8542V13.5Z"
                fill="#1C1B1F"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "UserCardSvg",
};
</script>
